module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAShJREFUKFNdkMFKw1AQRd/ExBhc2FRF0D8St1kW2lKewZguRJd+RzMzUNBUbLWI1S70A1y5EBEFce8/lKZv5BVbqrM+w73nglq4arW64nledzKZHLTb7e84jneMMUxEuzDjoihaDsOwJyIZMz/WarVNz/N6ALCPiF9TMIqipTAMOyJyycx3WusNAOgZY5rM/G4ZsFC5XD4TkQERXWut15RSfQA4RsTXWSJorTMReWLm3Hb0ff/WGHPKzM+L/S14LiJDZr6qVCqrQRAMHMc5ybLs5Q9oo0ulUu44Th8Rb5IkWR+Px12l1BERvc2jf2WscQcAckS8XzA+RMSPqcz/eQAAEfGh0WhsAUDXdd241Wp9zkH7kKapPxqNLoqiaNrB6/X6tuu6RER7P2YmhguOo+w2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/left.png
// module id = /Zlt
// module chunks = 1